import experiencesEn from './experiences.en';
import experiencesAr from './experiences.ar';
import educationEn from './education.en';
import educationAr from './education.ar';
import contact from './contact';

export const cvData = {
  en: {
    lang: 'en',
    dir: 'ltr',
    profile: {
      name: 'Samir Djelal',
      title: 'Group Chief Technology & Solution Officer',
      scope: 'Click2Secure • Payd • Starz TPA • Seguro • Trustcare',
      tagline: 'High-Throughput Systems • Payment Gateways • Regulatory Compliance • Cloud Defense & Crisis Engineering',
      location: 'Algiers, Algeria • Open to Global & Remote Advisory',
      email: contact.email,
      website: contact.website,
      websiteLabel: 'samirdjelal.com',
      linkedin: contact.linkedin,
      linkedinLabel: 'linkedin.com/in/samirdjelal',
      github: contact.github,
      githubLabel: 'github.com/samirdjelal',
      summary:
        'Executive technology leader and systems architect with 12+ years of experience engineering and scaling mission-critical platforms across fintech, healthtech, and cybersecurity. Currently serving as Group Chief Technology and Solution Officer across a shared resource hub spanning five enterprise entities. Proven track record leading high-concurrency payment gateway engineering (Rust, PHP/Laravel, Go), multi-cloud infrastructure resilience, and rigorous regulatory remediation—including directing code, infrastructure, and policy remediation for Payd to achieve full-scope PCI DSS v4.0.1 Service Provider compliance (audited and approved by external QSA), group-wide ISO 27001:2022 ISMS certification, and ADHICS healthcare compliance. Crisis-tested engineering leader who orchestrated zero-data-loss emergency snapshotting and rapid cloud migration during the AWS UAE regional incident under heavy production load. Architect and developer of Trax, a self-built unified observability and infrastructure fleet control platform engineered in Rust.',
    },
    achievements: [
      {
        badge: 'PCI DSS v4.0.1',
        title: 'Service Provider Compliance',
        detail: 'Directed full technical, code, and infrastructure remediation for Payd to achieve PCI DSS Service Provider compliance; audited and approved by external QSA.',
      },
      {
        badge: 'ISO 27001:2022',
        title: 'Enterprise ISMS Framework',
        detail: 'Oversaw group-wide certification, implementing comprehensive risk governance, host hardening, and operational security controls.',
      },
      {
        badge: 'Crisis DR Leadership',
        title: 'Zero-Loss Incident Failover',
        detail: 'Orchestrated emergency backups and rapid failover migration during the AWS UAE regional attack under peak production load with zero data loss in record time.',
      },
      {
        badge: 'Trax Platform',
        title: 'Proprietary Rust Engine',
        detail: 'Architected and developed a unified observability, server telemetry, and fleet control platform built from scratch in Rust (Actix-web, Tokio, SQLx).',
      },
    ],
    skillCategories: [
      {
        category: 'Core Systems & Backend',
        skills: [
          'Rust (Actix-web & Tokio)',
          'Trax Observability Engine',
          'PHP (Laravel)',
          'Go (Golang)',
          'C (Systems)',
          'Node.js & TypeScript',
          'Python',
          'PostgreSQL',
          'Redis',
          'High-Concurrency Architecture',
        ],
      },
      {
        category: 'Perimeter Defense & Security',
        skills: [
          'CrowdSec Threat Intelligence',
          'Suricata (IDS/IPS)',
          'OWASP Core Rule Set (CRS)',
          'ModSecurity WAF',
          'OPNsense & pfSense Firewalls',
          'AWS WAF & AWS Network Firewall',
          'Azure Firewall & Azure WAF',
          'Wazuh (SIEM, HIPS, IDS)',
          'Mutual TLS (mTLS)',
          'Vulnerability Remediation',
        ],
      },
      {
        category: 'Regulatory Governance & Audits',
        skills: [
          'PCI DSS v4.0.1 (Service Provider Remediation)',
          'ISO 27001:2022 (ISMS Framework)',
          'ADHICS & Abu Dhabi DOH Standards',
          'Automated AML / CTF / ABC Screening',
          'AOC / ROC Attestations',
          'Threat Modeling & Risk Registers',
        ],
      },
      {
        category: 'Cloud, Resilience & Automation',
        skills: [
          'Amazon Web Services (AWS)',
          'Microsoft Azure',
          'Multi-Cloud Disaster Recovery (DR)',
          'Emergency Snapshot & Live Migration',
          'Docker & Kubernetes',
          'Linux Administration (RHEL, Debian, Ubuntu)',
          'Nginx Reverse Proxy',
          'CI/CD (GitLab, GitHub Actions)',
          'n8n Workflow Automation',
          'Event-Driven Webhook Pipelines',
        ],
      },
    ],
    experiences: experiencesEn,
    education: educationEn,
    sections: {
      summary: 'Executive Profile',
      achievements: 'Key Executive Credentials & Impact',
      skills: 'Core Technology, Security & Systems Stack',
      experience: 'Professional Experience',
      education: 'Education & Academic Credentials',
      printButton: 'Print / Save as PDF',
      viewOnline: 'samirdjelal.com',
      switchLang: 'العربية (Arabic)',
      close: 'Close',
    },
  },
  ar: {
    lang: 'ar',
    dir: 'rtl',
    profile: {
      name: 'سمير جلال',
      title: 'رئيس قطاع التكنولوجيا والحلول للمجموعة (Group CTO & CSO)',
      scope: 'Click2Secure • Payd • Starz TPA • Seguro • Trustcare',
      tagline: 'الأنظمة الموزعة فائقة الأداء • بوابات الدفع الإلكتروني • الامتثال التنظيمي الصارم • الدفاع السحابي وهندسة الأزمات',
      location: 'الجزائر العاصمة • متاح للعمل والاستشارات عن بُعد عالمياً',
      email: contact.email,
      website: contact.website,
      websiteLabel: 'samirdjelal.com',
      linkedin: contact.linkedin,
      linkedinLabel: 'linkedin.com/in/samirdjelal',
      github: contact.github,
      githubLabel: 'github.com/samirdjelal',
      summary:
        'قائد تقني تنفيذي ومهندس معماري للأنظمة يتمتع بخبرة تتجاوز 12 عاماً في بناء وتوسيع المنصات الحيوية في مجالات التكنولوجيا المالية (Fintech)، والتكنولوجيا الصحية (Healthtech)، والأمن السيبراني. يشغل حالياً منصب رئيس قطاع التكنولوجيا والحلول للمجموعة عبر مركز موارد مشترك يخدم خمس شركات تابعة. يمتلك سجلاً حافلاً في قيادة هندسة بوابات الدفع فائقة الأداء بلغات Rust و PHP/Laravel و Go، وبناء البنى التحتية السحابية الهجينة والامتثال التنظيمي الصارم — بما في ذلك قيادة المعالجة التقنية والسياسات البرمجية لمنصة Payd لتحقيق الامتثال الكامل لمعيار PCI DSS v4.0.1 لمزودي الخدمات واجتياز تدقيق QSA الخارجي بنجاح، وقيادة تطبيق نظام إدارة أمن المعلومات ISO 27001:2022، ومواءمة معايير ADHICS للقطاع الصحي بأبوظبي. قيادة مثبتة في إدارة الأزمات والتعافي من الكوارث من خلال قيادة ترحيل سحابي طارئ دون أي فقدان للبيانات أثناء أزمة سحابة AWS في الإمارات تحت أقصى درجات الضغط والتشغيل. مطور منصة Trax الرائدة للمراقبة الموحدة والتحكم في الخوادم والمكتوبة بالكامل بلغة Rust.',
    },
    achievements: [
      {
        badge: 'معيار PCI DSS v4.0.1',
        title: 'امتثال مزودي الخدمات المالية',
        detail: 'قيادة المعالجة التقنية البرمجية والبنية التحتية والسياسات لشركة Payd لتحقيق الامتثال الكامل واجتياز تدقيق QSA الخارجي بنجاح.',
      },
      {
        badge: 'شهادة ISO 27001:2022',
        title: 'إطار أمن المعلومات المؤسسي',
        detail: 'الإشراف على نيل الشهادة على مستوى المجموعة وتطبيق نظام إدارة أمن المعلومات (ISMS) وإدارة المخاطر وتحصين الخوادم.',
      },
      {
        badge: 'قيادة التعافي من الأزمات',
        title: 'ترحيل طارئ بصفر فقدان للبيانات',
        detail: 'إنجاز النسخ الاحتياطي والترحيل الطارئ تحت أقصى ضغط تشغيلي أثناء أزمة سحابة AWS في الإمارات بصفر فقدان في البيانات وبوقت قياسي.',
      },
      {
        badge: 'منصة Trax الرائدة',
        title: 'محرك سيادي مبني بلغة Rust',
        detail: 'تصميم وبناء منصة موحدة للمراقبة عن بعد والقياس الآني والتحكم في أساطيل الخوادم من الصفر بلغة Rust (Actix-web، Tokio).',
      },
    ],
    skillCategories: [
      {
        category: 'الأنظمة الأساسية والمعالجة الخلفية',
        skills: [
          'لغة Rust (Actix-web و Tokio)',
          'محرك المراقبة Trax',
          'لغة PHP (Laravel)',
          'لغة Go (Golang)',
          'لغة C وبرمجة الأنظمة',
          'Node.js و TypeScript',
          'لغة Python',
          'قواعد بيانات PostgreSQL',
          'خوادم الذاكرة Redis',
          'معمارية التزامن العالي (High-Concurrency)',
        ],
      },
      {
        category: 'حماية المحيط والأمن السيبراني',
        skills: [
          'منظومة CrowdSec واستخبارات التهديدات',
          'منظومة Suricata (IDS/IPS)',
          'قواعد OWASP Core Rule Set (CRS)',
          'جدران تطبيقات الويب ModSecurity WAF',
          'جدران الحماية OPNsense و pfSense',
          'جدران حماية AWS WAF & Network Firewall',
          'جدران حماية Azure Firewall & WAF',
          'منصة Wazuh (SIEM، HIPS، IDS)',
          'بروتوكول التشفير المزدوج (mTLS)',
          'معالجة الثغرات والتحصين',
        ],
      },
      {
        category: 'الحوكمة التنظيمية والامتثال',
        skills: [
          'معيار PCI DSS v4.0.1 (معالجة مزود الخدمة)',
          'شهادة ISO 27001:2022 (إطار ISMS)',
          'معايير ADHICS ودائرة الصحة بأبوظبي',
          'الفحص الآلي لغسل الأموال (AML/CTF)',
          'تقارير وشهادات الاعتماد (AOC/ROC)',
          'نمذجة التهديدات وسجلات المخاطر',
        ],
      },
      {
        category: 'السحابة، الاستمرارية والأتمتة',
        skills: [
          'حوسبة Amazon Web Services (AWS)',
          'حوسبة Microsoft Azure',
          'التعافي من الكوارث متعدد السحابات (DR)',
          'النسخ الاحتياطي السريع والترحيل اللحظي',
          'حاويات Docker و Kubernetes',
          'إدارة أنظمة Linux (RHEL، Debian، Ubuntu)',
          'خوادم Nginx العكسية',
          'التكامل والنشر المستمر CI/CD',
          'أتمتة الأعمال باستخدام n8n',
          'مسارات الأحداث الموجهة (Webhooks)',
        ],
      },
    ],
    experiences: experiencesAr,
    education: educationAr,
    sections: {
      summary: 'الملف التنفيذي',
      achievements: 'أبرز الإنجازات والاعتمادات القيادية',
      skills: 'منظومة التقنيات والأنظمة والأمن',
      experience: 'الخبرات المهنية',
      education: 'المؤهلات العلمية والدبلومات',
      printButton: 'طباعة / حفظ كملف PDF',
      viewOnline: 'samirdjelal.com',
      switchLang: 'English',
      close: 'إغلاق',
    },
  },
};

export function getCvData(lang = 'en') {
  return lang === 'ar' ? cvData.ar : cvData.en;
}

export default cvData;
